<script setup>

import {ref} from 'vue'
import {useAuthStore} from "@/stores/auth.store";

const authStore = useAuthStore();
const email = ref('')
const password = ref('')


const login = async () => {
  await authStore.login(email.value, password.value);
}

</script>

<template>
  <van-form @submit="login">
    <van-space direction="vertical" fill>
      <van-row justify="center">
        <van-image
            src="./logo.png"
        />
      </van-row>
      <van-cell-group inset>
        <van-field
            v-model="email"
            name="email"
            label="Email"
            placeholder="Email"
            size="large"
            :rules="[{ required: true, message: 'Please input email' }]"
        />
        <van-field
            v-model="password"
            type="password"
            name="Password"
            label="Password"
            placeholder="Password"
            size="large"
            :rules="[{ required: true, message: 'Please input password' }]"
        />
      </van-cell-group>
      <div style="text-align: center; margin-top: 20px;">
        Don't have an account?
        <router-link to="/register">Register</router-link>
      </div>
      <van-divider/>
      <van-cell-group inset>
        <van-button block round type="success" native-type="submit">
          Login
        </van-button>
      </van-cell-group>
    </van-space>
  </van-form>
</template>
